import http from "@/utils/request";

const RoleApi = {
  listRole(data) {
    return http.sendRequest({
      METHOD_NAME: "roles.listRole",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
  listAllRole(data) {
    return http.sendRequest({
      METHOD_NAME: "roles.listAllRole",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
  addOrUpdateRole(data) {
    return http.sendRequest({
      METHOD_NAME: "roles.addOrUpdateRole",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
  deleteRole(data) {
    return http.sendRequest({
      METHOD_NAME: "roles.deleteRole",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
};
export default RoleApi;
